// extracted by mini-css-extract-plugin
export default {"root":"IconFilePDF_root__9sang"};